import CompoundSurvey from "./compound-survey";

export interface SerializedCompoundSurveyFrequency {
  surveyId: string;
  enabled?: boolean;
  forgettingNumber?: number;
  frequency?: string;
}

export default class CompoundSurveyFrequency {
  enabled: boolean;
  forgettingNumber?: number;
  frequency?: string;
  surveyId: string;

  /**
   * For testing purpose. Do not use as an UUID
   */
  get id() {
    return this.surveyId;
  }

  constructor(survey: CompoundSurvey);
  constructor(serialized: SerializedCompoundSurveyFrequency);

  constructor(param: SerializedCompoundSurveyFrequency | CompoundSurvey) {
    if (param instanceof CompoundSurvey) {
      this.surveyId = param.id;
      this.enabled = false;
      this.frequency = "never";
      this.forgettingNumber = 0;
    } else {
      const { surveyId, forgettingNumber, frequency, enabled } = param;
      this.surveyId = surveyId;
      this.forgettingNumber = forgettingNumber;
      this.frequency = frequency;
      this.enabled = enabled || false;
    }
  }

  serialize(): SerializedCompoundSurveyFrequency {
    return {
      surveyId: this.surveyId,
      forgettingNumber: this.forgettingNumber,
      frequency: this.frequency
    };
  }
}
